export const SITE_ORIGIN = "https://create.musicfy.lol";
export const SITE_NAME = "Musicfy AI";
export const DOCS_ORIGIN = "https://docs.musicfy.lol";

export const DEFAULT_TITLE =
  "Musicfy | Create AI Covers with your Favorite Voices!";

export const DEFAULT_DESCRIPTION =
  "Use our industry-leading AI voice song generator to create covers with AI in any voice. Choose from 100,000+ voices or make a clone of yours.";

/** Default social share image (brand mark hosted on Framer CDN). */
export const DEFAULT_OG_IMAGE =
  "https://framerusercontent.com/images/0FLYNLQf4KYAg0O3pG4MXWtZRU.png";

export const FAVICON_URL = DEFAULT_OG_IMAGE;

export const ORGANIZATION_LOGO_URL = DEFAULT_OG_IMAGE;

/** Paths (and prefixes) that must not be indexed. */
export const NOINDEX_PATH_PREFIXES = [
  "/manage",
  "/api-access",
  "/admin",
  "/auth",
  "/account",
  "/tokens",
  "/email-offer",
  "/s",
  "/pro-tools",
] as const;

/**
 * Exact paths that stay indexable even when under a NOINDEX prefix.
 * Stem Splitter is a public acquisition landing; other /pro-tools/* stay noindex.
 */
export const INDEXABLE_EXACT_PATHS = ["/pro-tools/stem-splitter"] as const;

/** Exact public paths that should be indexed (voice model pages handled separately). */
export const PUBLIC_SITEMAP_PATHS = [
  "/",
  "/create/voice",
  "/create/song",
  "/create/text-to-music",
  "/support/faq",
  "/pro-tools/stem-splitter",
] as const;
